import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/topicMemberRoleService";
const store = {};
const mutations = {
    GET_DETAIL(state, posts) {
        if (posts.success == true) {
            state.topicMemberRoleDetail = posts.data;
            state.topicMemberRoleDetailChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    SET_TOPIC_MEMBER_ROLE_LIST(state, posts) {
        state.topicMemberRoleList = posts;
        state.topicMemberRoleListIsLoading = false;
    },
    SAVE_DETAIL(state, posts) {
        if (posts.success == true) {
            state.topicMemberRoleDetailChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    DELETE_TOPIC_MEMBER_ROLE(state) {
        state.topicMemberRoleDeleted = true;
    },
};
const state = {
    topicMemberRoleListIsLoading: false,
    topicMemberRoleList: [],
    topicMemberRoleDetail: {},
    topicMemberRoleDetailChanged: false,
    topicMemberRoleDeleted: false
};
const getters = {};
const actions = {
    getTopicMemberRoleList({ commit }) {
        state.topicMemberRoleListIsLoading = true;
        axios
            .get(baseUri + '/GetList')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_TOPIC_MEMBER_ROLE_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getTopicMemberRoleDetail({ commit }, data) {
        state.topicMemberRoleListIsLoading = true;
        var formData = new FormData();
        formData.append("tmrId", data.tmrId);
        axios
            .post(baseUri + '/GetDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_DETAIL', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    saveTopicMemberRoleDetail({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.topicMemberRoleDetail));
        axios
            .post(baseUri + '/SaveDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_DETAIL', res.data);
                } else {
                    alert("An error occured while updating: " + res.data.errorMessage);
                }
            });
    },
    deleteTopicMemberRole({ commit }, data) {
        var formData = new FormData();
        formData.append("tmrId", data.tmrId);
        axios
            .post(baseUri + '/Delete', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('DELETE_TOPIC_MEMBER_ROLE');
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}